import { Fragment, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import PrivateRoute from "routers/private-route";
import ConfigDB from "../Config/ThemeConfig";
import AnimationThemeContext from "../_helper/AnimationTheme";
import CustomizerContext from "../_helper/Customizer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Taptop from "./TapTop";
import { useUserProfile } from "hook/useUserProfile";
import Footer from "./Footer";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppLayout = ({ children, ...rest }) => {
  const { layout } = useContext(CustomizerContext);
  const { sidebarIconType } = useContext(CustomizerContext);

  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const sideBarIcon =
    localStorage.getItem("sidebar_icon_type") || sidebarIconType;
  const location = useLocation();
  const { animation } = useContext(AnimationThemeContext);
  const animationTheme =
    localStorage.getItem("animation") ||
    animation ||
    ConfigDB.data.router_animation;

  const { data } = useUserProfile();

  return (
    <Fragment>
      <ScrollToTop />
      <Taptop />
      <div
        className={`page-wrapper ${layout1}`}
        sidebar-layout={sideBarIcon}
        id="pageWrapper"
      >
        <Header />
        <div className="page-body-wrapper">
          <Sidebar />
          <div className="page-body">
            <TransitionGroup {...rest}>
              <CSSTransition
                key={location.key}
                timeout={100}
                classNames={animationTheme}
                unmountOnExit
              >
                <PrivateRoute>{children}</PrivateRoute>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>
      </div>
      <Footer />

      <ToastContainer />
    </Fragment>
  );
};
export default AppLayout;
